__turbopack_context__.v({
  "card": "style-module-scss-module__OAUeya__card",
  "ctaBtn": "style-module-scss-module__OAUeya__ctaBtn",
  "ctaDotIcon": "style-module-scss-module__OAUeya__ctaDotIcon",
  "description": "style-module-scss-module__OAUeya__description",
  "dot-icon-animation": "style-module-scss-module__OAUeya__dot-icon-animation",
  "founderPosition": "style-module-scss-module__OAUeya__founderPosition",
  "image": "style-module-scss-module__OAUeya__image",
  "imageWrapper": "style-module-scss-module__OAUeya__imageWrapper",
  "isDark": "style-module-scss-module__OAUeya__isDark",
  "title": "style-module-scss-module__OAUeya__title",
});
